module.exports = "<h3>\r\n    Liste der Medien\r\n</h3>\r\n\r\n<app-table-template *ngIf=\"medias && columns\" [data]=\"medias\" [columns]=\"columns\"></app-table-template><br>"


//////////////////
// WEBPACK FOOTER
// ./src/app/publisherMedia/publisher.media.component.html
// module id = 269
// module chunks = 1